export const RECONCILIATION_CURRENCIES = ['USD', 'EUR', 'TRY', 'GBP'];

export const REVIEW_FILTERS = [
  { value: 'all', label: 'Tümü' },
  { value: 'overdue', label: 'Gecikmiş' },
  { value: 'soon', label: 'Yaklaşan' },
  { value: 'ok', label: 'Güncel' },
  { value: 'never', label: 'Hiç yapılmadı' },
  { value: 'mismatch', label: 'Açık fark' }
];

export const REVIEW_SORTS = [
  { value: 'urgency', label: 'Aciliyete göre' },
  { value: 'lastDate', label: 'Son mutabakat (eskiden yeniye)' },
  { value: 'name', label: 'Firma adı' }
];

export const COMPANY_STATUS_FILTERS = [
  { value: 'all', label: 'Tümü' },
  { value: 'aktif', label: 'Aktif' },
  { value: 'pasif', label: 'Pasif' }
];

// '' = firma varsayilan sikligi kullanir (sunucudaki varsayilan, genelde 90 gun)
export const REVIEW_INTERVAL_PRESETS = [30, 60, 90, 180, 365];

export const formatInterval = (days) => {
  const labels = { 30: 'Aylık', 60: '2 ayda bir', 90: '3 ayda bir', 180: '6 ayda bir', 365: 'Yılda bir' };
  return labels[days] || `${days} günde bir`;
};

// 0 -> 'Bugün', 1 -> 'Dün', 12 -> '12 gün önce', 75 -> '2 ay önce', 800 -> '2 yıl önce'
export const formatDaysAgo = (days) => {
  if (days === null || days === undefined) return '';
  if (days === 0) return 'Bugün';
  if (days === 1) return 'Dün';
  if (days < 45) return `${days} gün önce`;
  if (days < 730) return `${Math.round(days / 30)} ay önce`;
  return `${Math.floor(days / 365)} yıl önce`;
};

// Satirdaki guncellik rozetinin metni + tonu
export const getReviewStatusMeta = (company) => {
  switch (company.reviewStatus) {
    case 'overdue':
      return {
        label: 'Gecikti',
        detail: `${Math.abs(company.daysUntilDue)} gün`,
        className: 'tone-danger',
        urgent: true
      };
    case 'soon':
      return {
        label: company.daysUntilDue === 0 ? 'Bugün' : 'Yaklaşıyor',
        detail: company.daysUntilDue === 0 ? 'son gün' : `${company.daysUntilDue} gün kaldı`,
        className: 'tone-warning',
        urgent: false
      };
    case 'ok':
      return { label: 'Güncel', detail: `${company.daysUntilDue} gün kaldı`, className: 'tone-success', urgent: false };
    case 'never':
      return { label: 'Hiç yapılmadı', detail: '', className: 'tone-info', urgent: true };
    default:
      return { label: 'Pasif', detail: '', className: 'border-transparent bg-dark-muted/20 text-dark-muted', urgent: false };
  }
};

export const matchesReviewFilter = (company, filter) => {
  if (filter === 'mismatch') return Boolean(company.lastEvent && company.lastEvent.hasMismatch);
  if (filter === 'all') return true;
  return company.reviewStatus === filter;
};

// Sunucu aciliyet sirasini zaten verir; 'urgency' o sirayi korur.
export const sortCompanies = (companies, sort) => {
  const list = [...companies];

  if (sort === 'name') {
    return list.sort((a, b) => a.name.localeCompare(b.name, 'tr'));
  }

  if (sort === 'lastDate') {
    // Hic yapilmamislar en ustte, sonra en eski mutabakat
    return list.sort((a, b) => {
      const left = a.lastEvent ? a.lastEvent.reconciledDate : '';
      const right = b.lastEvent ? b.lastEvent.reconciledDate : '';
      if (left !== right) return left < right ? -1 : 1;
      return a.name.localeCompare(b.name, 'tr');
    });
  }

  return list;
};

export const formatBalance = (amount, currency = 'USD') => {
  if (amount === null || amount === undefined) {
    return '—';
  }

  return new Intl.NumberFormat('tr-TR', {
    style: 'currency',
    currency,
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(Number(amount));
};

// --- Turkce sayi girisi (binlik ayraci '.', ondalik ',') -------------------

// Kaydedilmis sayisal degeri gosterime cevirir: 3186576.5 -> '3.186.576,50'
export const formatTrNumberValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '';
  }

  const parsed = Number(value);
  if (Number.isNaN(parsed)) {
    return '';
  }

  return new Intl.NumberFormat('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(parsed);
};

// Kullanici YAZARKEN kullanilir: yarim kalmis girisi bozmadan gruplar.
// '3186576,5' -> '3.186.576,5' (sondaki sifir zorlanmaz), '3186576,' -> '3.186.576,'
export const formatTrNumberInput = (input) => {
  if (input === null || input === undefined || input === '') {
    return '';
  }

  let raw = typeof input === 'number' ? String(input).replace('.', ',') : String(input);
  const negative = raw.trim().startsWith('-');

  // Nokta ondalik ayraci olarak yazildiysa virgule cevir ("1234.56" -> "1234,56").
  // Birden fazla nokta varsa ya da sonrasinda 3 hane varsa binlik ayracidir, silinir.
  if (!raw.includes(',')) {
    const dotCount = (raw.match(/\./g) || []).length;
    if (dotCount === 1 && /\.\d{1,2}$/.test(raw)) {
      raw = raw.replace('.', ',');
    }
  }

  raw = raw.replace(/\./g, '');

  const hasComma = raw.includes(',');
  const [integerRaw, ...decimalParts] = raw.split(',');
  const integerDigits = integerRaw.replace(/\D/g, '');
  const decimalDigits = decimalParts.join('').replace(/\D/g, '').slice(0, 2);

  if (!integerDigits && !hasComma) {
    return negative ? '-' : '';
  }

  const grouped = (integerDigits || '0').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `${negative ? '-' : ''}${grouped}${hasComma ? `,${decimalDigits}` : ''}`;
};

// '3.186.576,50' -> 3186576.5 | bos -> null | cozulemeyen -> undefined
export const parseTrNumber = (input) => {
  if (input === null || input === undefined) {
    return null;
  }

  const text = String(input).trim();
  if (!text) {
    return null;
  }

  const normalized = text.replace(/\./g, '').replace(',', '.').replace(/[^\d.-]/g, '');
  if (!normalized || normalized === '-' || normalized === '.') {
    return undefined;
  }

  const parsed = Number.parseFloat(normalized);
  return Number.isNaN(parsed) ? undefined : parsed;
};

// Fark hucresinin etiketi + renk sinifi
export const getDifferenceMeta = (record) => {
  if (record.balancesMissing) {
    return { label: '—', className: 'text-dark-muted', tone: 'muted' };
  }

  if (!record.hasMismatch) {
    return { label: 'Mutabık', className: 'tone-success', tone: 'match' };
  }

  return {
    label: formatBalance(record.difference, record.currency),
    className: 'tone-danger',
    tone: 'mismatch'
  };
};

export const reconciliationExcelMapper = (company) => {
  const last = company.lastEvent;
  const meta = getReviewStatusMeta(company);

  return {
    'Firma': company.name,
    'Döviz': last ? last.currency : company.defaultCurrency,
    'Son Mutabakat': last ? last.reconciledDate : '-',
    'Kaç Gün Önce': company.daysSince === null ? '-' : company.daysSince,
    'Sıklık (gün)': company.intervalDays,
    'Sonraki Mutabakat': company.dueDate || '-',
    'Durum': meta.detail ? `${meta.label} (${meta.detail})` : meta.label,
    'Bizim Bakiye': last && last.ourBalance !== null ? last.ourBalance : '',
    'Karşı Bakiye': last && last.theirBalance !== null ? last.theirBalance : '',
    'Fark': last && last.difference !== null ? last.difference : '',
    'Son Not': last && last.note ? last.note : '-'
  };
};
